import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from 'common/components/elements/buttons/primary';
import VideoCardContent from './video';
import PhotosetCardContent from './photoset';
import DateFormatter from 'common/utils/DateFormatter';
import TruncateText from 'common/components/elements/truncate-text';
import PremiumLabel from '../premium-label';
import MembershipsForContentModal from './memberships-for-content-modal';
import QueryParams from 'sites/utils/QueryParams';
import Icon from 'common/components/elements/icons';
import { mediaAvailablePrices } from "sites/api/MixApi";

import './style.scss'

import { useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import cx from 'classnames'
import {
   MediaChip,
   MediaInfoChip,
   MediaButton,
   MediaLableItem,
   MediaMemberBottonOptions,
} from 'common/components/modules/media';
import { useSelector } from 'react-redux';
import { isAgeVerificationRequiredSelector } from 'sites/state/modules/common/selectors';
import { filterBadWords } from 'common/utils/filter-bad-words';
import {
   setShareModalAction as setShareModal,
   setShowNSFWModalAction } from 'sites/state/modules/common/actions';
import { useDispatch } from 'react-redux';


const ContentCard = ({
   collectionType,
   data,
   onClickLike,
   goTo,
   isAuthUser,
   goToMediaDetails,
   downloadDate,
   onClickJoin,
   onClickUnlock,
   onLikClick,
   paymentButtonLoading,
   isHomepage,
   onClickTip,
   videoType,
   onShare,
   unlockedDate,
   onSelectMembership,
   toggleWatchStatus,
   siteInfo,
   urlParamForAccess,
   playPreviewId,
   onUpdatePlayPreviewId,
   bundleName,
   isMedia,
   isDownloaded,
   onChangeFavoriteItem,
   className = '',
   thumbnailIsSfw,
   videoPreviewIsSfw,
   expiredDays = false,
}) => {
   const isAgeVerificationRequired = useSelector(isAgeVerificationRequiredSelector)
   const isLockedForSFW =  isAgeVerificationRequired && !thumbnailIsSfw;
   const screenWidth = useSelector(state => state.common.screenWidth);

   const [membershipsForContentModal, setMembershipsForContentModal] = useState({
      isOpen: false,
      isFetching: true,
      pricings: [],
   })
   const date = DateFormatter.convertToUserTz(data.publish_date);
   const showComingSoon = !!data.is_future_publish_enabled;
   const isPremium = 'only_member_can_unlock' === data.stream_status;
   const isPreRelease = 'pre_release' === data.stream_status && 'need_to_soon' !== data.stream_state && showComingSoon;

   const [showButtons, setShowButtons] = useState(true)
   // const timer = useRef();
   let tipOnContentData = {
      "resource_id": data.id,
      "resource_type": collectionType,
   }

   let location = useLocation();

   const [isHoveredOnTheCard, setIsHoveredOnTheCard] = useState(false)
   const dispatch = useDispatch()


   useLayoutEffect(() => {
      let param = QueryParams.getParam('q')
      if(param){
         let encodedURL = decodeURIComponent(param)
         let obj_URL = JSON.parse(encodedURL)
         if(obj_URL.hasOwnProperty('pricing')){
            setShowButtons(false)
            return
         }
      }
   }, [location.search])

   useEffect(() => {
      const fetchAvailablePrices = async () => {
         await getAvailablePrices();
      }
      const modalQuery = QueryParams.getParam('memberships-for-content')
      if(modalQuery) {
         const [type, id] = modalQuery.split('-')
         const contentType = collectionType === 'video' ? videoType : collectionType
         if(type === contentType && +id === data.id) {
            fetchAvailablePrices().then(() => {

            }).catch(() => {

            });
         }
      }

      // eslint-disable-next-line
   }, [])

   // eslint-disable-next-line no-unused-vars
   const getDescriptionText = () => {
      let text = `${ DateFormatter.getDate(date) }`

      if(downloadDate){
         text = `Downloaded on ${ DateFormatter.convertToUserTz(downloadDate, 'MMM DD, YYYY hh:mm A') } ${ (!!data?.download_price && data.download_price !== '0.00') ? `(${ data.download_price } USD)` : '' }`
      }
      if(showComingSoon){
         text = 'Coming soon'
      }
      if(unlockedDate){
         text = `${ DateFormatter.convertToUserTz(unlockedDate, 'MMM DD, YYYY hh:mm A') } ${ (!!data?.unlock_price && data.unlock_price !== '0.00') ? `(${ data.unlock_price } USD)` : '' }`
      }
      return text;
   }


   const getVoiceIconRightPosition = () => {
      let right = 16;
      if(!data.is_deleted){
         if(!!data.comments_count) right = right + 32
         if(!!isAuthUser) right = right + 64
         if(!!onShare) right = right + 32
      }
      return right
   }


   const getAvailablePrices = async () => {
      setMembershipsForContentModal({
         isOpen: true,
         isFetching: true,
         pricings: [],
      });
      const { id } = data;
      const param = QueryParams.getParam('q');
      let objURL = {};
      if(param){
         const encodedURL = decodeURIComponent(param);
         objURL = JSON.parse(encodedURL);
      }
      let query = [];
      if(objURL.pricing){
         query = [
            [`pricing_id=${ objURL.pricing }`],
         ]
      }
      const apiTypes = {
         photoset: 'photosets',
         video: 'videos',
      }
      const type = apiTypes?.[collectionType] || '';
      if('video' === collectionType && 'livestream' === videoType){
         query = [...query, 'video_type=livestream'];
      }
      let params = '';
      if(query.length > 0){
         params = query.join('&');
      }
      try {
         const { data: { pricings } } = await mediaAvailablePrices(id, type, params);
         // console.log(pricings, 'pricings')
         setMembershipsForContentModal({
            isOpen: true,
            isFetching: false,
            pricings: pricings,
         });
      } catch (error) {
         setMembershipsForContentModal({
            isOpen: true,
            isFetching: false,
            pricings: [],
         })
      }
   }

   const contentButtonOptions = (
      <ContentButtonOptions
         data={ data }
         isAuthUser={ isAuthUser }
         goToMediaDetails={ goToMediaDetails }
         onClickTip={ () => onClickTip(true, tipOnContentData) }
         onShare={ () => {
            dispatch(setShareModal({
               isOpen: true,
               additionalInfo: {
                  contentType: videoType === 'livestream' ? videoType : collectionType,
                  contentId: data?.id,
                  contentTitle: data?.title,
               },
            }))
            // if(videoType === 'livestream') {
            //    onShare(data.id, videoType)
            // }
            // else {
            //    onShare(data.id, collectionType)
            // }
         } }
         showShare={ Boolean(onShare) }
         onClickLike={ onClickLike }
         onClickLock={ async () => await getAvailablePrices() }
         siteInfo={ siteInfo }
         isHomepage={ isHomepage }
         showButtons={ showButtons }
         stream_state={ data?.stream_state }
         isMedia={ isMedia }
         onChangeFavoriteItem={ () => onChangeFavoriteItem(data?.id, videoType === 'livestream' ? 'recorded_stream' : collectionType) }
         collectionType={ videoType === 'livestream' ? 'recorded stream' : collectionType }
      />
   )
   let lockedForAllMemberships = false;

   const goToLocation = () => {
      let param = QueryParams.getParam('q')
      if(!param) return goTo;
      let encodedURL = decodeURIComponent(param)
      let obj_URL = JSON.parse(encodedURL)
      if(obj_URL?.pricing){
         return goTo + `?pricing=${ obj_URL?.pricing }`
      }
      return goTo;
   }

   const onLongTouch = (e) => {
      if(collectionType === 'video' && playPreviewId !== data.id && onUpdatePlayPreviewId){
         // e.preventDefault();
         if(data.system_preview_video_full_src || data.custom_preview_video_full_src){
            onUpdatePlayPreviewId(data.id)
         } else {
            onUpdatePlayPreviewId(null);
         }
      }
   }

   const getIsShowAgeVerifyLayer = () => {
      switch (true) {
         case !isAgeVerificationRequired || !isHoveredOnTheCard || Boolean(data.blurhash):
            return false

            // If photoset whatch on thumbnailIsSfw
         case collectionType === 'photoset' && thumbnailIsSfw:
            return false

            // If video, preview is enabled show layer depending on videoPreviewIsSfw
         case collectionType === 'video' && (data.system_preview_video_full_src || data.custom_preview_video_full_src) && videoPreviewIsSfw:
            return false

            // If video, no preview show layer depending on thumbnailIsSfw
         case collectionType === 'video' && !data.system_preview_video_full_src && !data.custom_preview_video_full_src && data.poster_src && thumbnailIsSfw:
            return false

         default:
            return true
      }
   }

   return (
      <>
         <Link
            onTouchStart={ (e) => {
               if(collectionType === 'video'){
                  onLongTouch(e)
               }
            } }
            onClick={ onLikClick ? (e) => {
               onLikClick()
            } : (e) => {
               if(!goTo) {
                  e.preventDefault()
               }
            } }
            to={ goToLocation }
            className={ cx({
               'text-major-dark bg-panel dark:bg-panel-dark rounded-lg': true,
               [className]: className,
            }) }
         >
            <div className='flex flex-col sites-media-card'>
               <div
                  className={ cx({
                     ' flex flex-col relative justify-end items-center overflow-hidden aspect-ratio-padding ': true,
                     // 'rounded-lg': !isMedia.showNewStyles,
                     'rounded-lg': true,
                  }) }
                  onMouseEnter={ () => setIsHoveredOnTheCard(true) }
                  onMouseLeave={ () => setIsHoveredOnTheCard(false) }
               >
                  <div
                     className='absolute top-0 left-0 z-20 pt-2 px-2 flex items-center gap-2 justify-between w-full'
                  >
                     <div className='flex gap-2 items-center'>
                        {
                           showButtons && siteInfo?.watched_unwatched_label && (!!data.is_published || data?.is_publish) && !Boolean(data.is_available_pricings) && isAuthUser && data.watched &&
                           <MediaButton
                              iconName='views'
                              dataToolTipContent='Mark as unwatched'
                              onClick={ (e) => {
                                 e.preventDefault()
                                 e.stopPropagation()
                                 toggleWatchStatus()
                              } }
                           />
                        }
                        {
                           ((!!data.is_published && !!data.new && !isPreRelease) || (data.new && isMedia.showNewStyles)) &&
                           <MediaInfoChip
                              text='NEW'
                           />
                        }
                        {
                           data.is_updated && !data.watched && ((!!data.is_published && !!siteInfo.photoset_updated_label && !isPreRelease) || (!!siteInfo.photoset_updated_label && isMedia.showNewStyles)) &&
                           <MediaInfoChip
                              text='Updated'
                           />
                        }
                        {
                           !!bundleName &&
                              <MediaLableItem
                                 iconName='bundle'
                                 tooltipContent={ `From ${ bundleName }` }
                              />
                        }
                        {
                           isMedia.showNewStyles && data.watched &&
                           <MediaButton
                              iconName='views'
                              dataToolTipContent='Seen'
                              onClick={ (e) => {
                                 e.preventDefault()
                              } }
                           />
                        }
                        {
                           isDownloaded &&
                           <MediaLableItem
                              iconName='download'
                              tooltipContent={ isMedia.showNewStyles ? 'Downloadable' : `Download`  }
                           />
                        }
                        {
                           isPremium &&
                              <PremiumLabel
                                 whithOpacit={ false }
                                 className='!m-0 !rounded'
                                 paddingX='2'
                                 paddingY='[5px]'
                              />
                        }
                        {
                           isPreRelease &&
                              <MediaLableItem
                                 iconName='launch'
                                 text='Prerelease'
                                 withoutBackground
                              />
                        }
                     </div>
                     <div
                        id={ `${ collectionType }_media_chip_${ data.id }` }
                        className='flex gap-2 flex-row-reverse'
                     >
                        <MediaChip
                           countOrDuration={ collectionType === 'video' ? data.duration : data.photos_count }
                           type={ collectionType }
                           isBlurBackground={ false }
                        />
                     </div>
                  </div>
                  {
                     getIsShowAgeVerifyLayer() && (
                        <div
                           className='absolute top-0 flex flex-col rounded-lg items-center justify-center gap-4 w-full h-full z-1 bg-major-60'
                           style={ {
                              backdropFilter: 'blur(32px)',
                           } }
                        >
                           <p className='text-lg font-semibold text-major-dark text-center'>Verify age to unblur content</p>
                           <Button
                              text={  'Verify my age' }
                              borderRadius='large'
                              backgroundColor={ 'transparent' }
                              textColor='major-dark'
                              textSize='small'
                              onClick={ (e) => {
                                 e.preventDefault()
                                 e.stopPropagation()
                                 dispatch(setShowNSFWModalAction(true))
                              } }
                              classNames='!w-fit border border-major-dark py-2.5 px-3.5'
                              textMarginX='0'
                           />
                        </div>
                     )
                  }
                  {
                     collectionType === 'video' && expiredDays && !isHoveredOnTheCard && (
                        <div
                           className='absolute top-0 flex flex-col rounded-lg items-center bg-major-60 justify-center gap-1 w-full h-full z-1'
                           // style={ {
                           //    // backdropFilter: 'blur(32px)',
                           // } }
                        >
                           <Icon
                              name='download'
                              size='2xl'
                              color='major-dark'
                           />
                           <p className='text-lg font-semibold text-major-dark text-center'>Download is available for {expiredDays} day{expiredDays > 1 ? 's' : ''}</p>
                        </div>
                     )
                  }
                  {
                     collectionType === 'video' && (
                        <VideoCardContent
                           posterSrc={ data.poster_src }
                           showComingSoon={ showComingSoon }
                           previewSrc={ data.system_preview_video_full_src || data.custom_preview_video_full_src }
                           date={ data.publish_date }
                           blurhash={ data.blurhash }
                           onClickJoin={ () => {
                              let type = 'videoId';
                              if(videoType === 'livestream'){
                                 type = 'recordId'
                              }
                              onClickJoin(`?${ type }=${ data.id }`)
                           } }
                           streamStatus={ data.stream_status }
                           streamPrice={ data.stream_price }
                           onClickUnlock={ () => {
                              const { id, title, stream_price } = data
                              onClickUnlock({ id, title, stream_price })
                           } }
                           paymentButtonLoading={ paymentButtonLoading }
                           isCustomPreview={ Boolean(data.custom_preview_video_full_src) }
                           voiceIconRightPosition={ getVoiceIconRightPosition() }
                           streamState={ data.stream_state }
                           isLockedForAllMemberships={ lockedForAllMemberships }
                           siteInfo={ siteInfo }
                           isHomepage={ isHomepage }
                           isPlayPreview={ playPreviewId === data.id }
                           videoId={ data.id }
                           endsIn={ !!data?.show_public_countdown ? data?.ends_in : null }
                           isLockedForSFW={ isLockedForSFW }
                           cannotPreviewForSfw={ isAgeVerificationRequired && !videoPreviewIsSfw }
                           isAutoPlay={ isHoveredOnTheCard && (data.system_preview_video_full_src || data.custom_preview_video_full_src) && screenWidth > 1024 }
                           screenWidth={ screenWidth }
                           setIsAutoPlay={ (bool) => setIsHoveredOnTheCard(bool) }
                        >
                           {contentButtonOptions}
                        </VideoCardContent>
                     )
                  }
                  {
                     collectionType === 'photoset' && (
                        <PhotosetCardContent
                           count={ data.photos_count }
                           img={ isAgeVerificationRequired && Boolean(data.sfw_thumbnail) ? data.sfw_thumbnail : data.cover_photo }
                           showComingSoon={ showComingSoon }
                           date={ data.publish_date }
                           blurhash={ data.blurhash }
                           onClickJoin={ () => onClickJoin(`?photosetId=${ data.id }`) }
                           streamStatus={ data.stream_status }
                           streamPrice={ data.stream_price }
                           onClickUnlock={ () => {
                              const { id, title, stream_price } = data
                              onClickUnlock({ id, title, stream_price })
                           } }
                           paymentButtonLoading={ paymentButtonLoading }
                           streamState={ data.stream_state }
                           isLockedForAllMemberships={ lockedForAllMemberships }
                           endsIn={ !!data?.show_public_countdown ? data?.ends_in : null }
                           isLockedForSFW={ isLockedForSFW }
                        >
                           {contentButtonOptions}

                        </PhotosetCardContent>
                     )
                  }
               </div>
               {
                  !isMedia.showNewStyles && <>
                     <div className='w-full flex items-start gap-1.5 mt-2'>
                        {
                           Boolean(data?.is_pinned)  &&
                           <Icon
                              name={ `pin` }
                              color={ `warning` }
                              darkColor={ `warning-dark` }
                              className={ `h-5 w-5 min-h-[20px] min-w-[16px] rotate-[35deg] mt-0.5` }
                              size={ `xl` }
                              data-tooltip-content={ 'Pinned' }
                              data-tooltip-id={ 'ams-top-tooltip' }
                           />
                        }
                        <div className='flex flex-col gap-0.5'>
                           <TruncateText
                              text={ isAgeVerificationRequired ? filterBadWords(data.title) : data.title }
                              // notranslate-content-title
                              textClass='text-xl font-bold text-major leading-6 dark:text-major-dark title dark:shadow-none notranslate'
                              textSize='20px'
                              fontWeight='700'
                           />
                           <span className='panel-description text-placeholder dark:text-placeholder-dark font-normal description'>
                              {siteInfo?.timestamp ? collectionType === 'video' ? 'Video • ' : 'Photoset • ' : ''}
                              { siteInfo?.timestamp && getDescriptionText() }
                           </span>
                        </div>
                     </div>
                  </>
               }
            </div>
         </Link>
         {
            membershipsForContentModal && membershipsForContentModal?.isOpen && (
               <MembershipsForContentModal
                  onClose={ () => setMembershipsForContentModal({
                     isOpen: false,
                     isFetching: false,
                     pricings: [],
                  }) }
                  data={ data }
                  isMobile={ window.innerWidth < 701 }
                  onSelectMembership={ onSelectMembership }
                  type={ collectionType === 'video' ? videoType : collectionType }
                  urlParamForAccess={ urlParamForAccess }
                  isAuthUser={ isAuthUser }
                  availablePricings={ membershipsForContentModal?.pricings || [] }
                  isLoading={ membershipsForContentModal?.isFetching }
               />
            )
         }
      </>
   );
};


const ContentButtonOptions = ({
   data,
   goToMediaDetails,
   isAuthUser,
   onClickTip,
   showShare,
   onShare,
   onClickLike,
   onClickLock,
   siteInfo,
   isHomepage,
   showButtons,
   stream_state,
   isMedia,
   onChangeFavoriteItem,
   collectionType,
}) => {

   const showComment = showButtons && !!data.comments_count && siteInfo?.total_comment_counts && !!data.can_read_comments;
   const showLock = Boolean(data.is_available_pricings && stream_state !== 'free');
   const canLike = Boolean(isMedia.showButtons && showButtons && siteInfo?.like && isAuthUser)
   const canShare = Boolean(isMedia.showButtons && showButtons && siteInfo?.share && !!showShare)
   const canSendTip = Boolean(isMedia.showButtons && showButtons && siteInfo?.tip && isAuthUser)
   const canChangeFavorite = Boolean(isAuthUser)
   return (
      (!data.is_deleted  && (canLike || canShare || canSendTip || canChangeFavorite || showLock || showComment)) &&
         <div
            className='absolute left-0 bottom-0 flex gap-3 justify-between items-center z-40 w-full p-2 pt-3'
         >
            {
               (showLock || showComment) && (
                  <div
                     // className='absolute left-0 bottom-0 z-40 ml-2 mb-2 flex gap-2'
                     className='flex gap-3'
                  >
                     {

                        showLock && (
                           <MediaButton
                              iconName='lock'
                              onClick={ (e) => {
                                 e.preventDefault()
                                 e.stopPropagation()
                                 if(data?.is_available_pricings) {
                                    onClickLock()
                                 }
                              } }
                           />
                        )
                     }
                     {
                        showComment &&
                        <MediaButton
                           iconName='comment'
                           onClick={ (e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              goToMediaDetails()
                           } }
                           text={ data.comments_count }
                        />
                     }
                  </div>
               )
            }
            {
               (canLike || canShare || canSendTip || canChangeFavorite)  && (

                  <MediaMemberBottonOptions
                     onChangeFavoriteItem={ onChangeFavoriteItem }
                     isLiked={ data.is_liked }
                     id={ data.id }
                     isFavorite={ data.is_favorite }
                     onClickLike={ data.is_deleted ? null : () => onClickLike() }
                     canLike={ canLike }
                     canShare={ canShare }
                     canSendTip={ canSendTip }
                     canChangeFavorite={ canChangeFavorite }
                     onShare={ onShare }
                     onClickTip={ onClickTip }
                     collectionType={ collectionType }

                  />
               )
            }
         </div>
   )
}

ContentCard.propTypes = {
   data: PropTypes.object,
   title: PropTypes.string,
   goTo: PropTypes.string,
   onClickLike: PropTypes.func,
   goToMediaDetails: PropTypes.func,
   downloadDate: PropTypes.string,
   isAuthUser: PropTypes.bool,
   collectionType: PropTypes.oneOf([
      'video',
      'photoset',
   ]),
   onClickJoin: PropTypes.func,
   onClickUnlock: PropTypes.func,
   onLikClick: PropTypes.func,
   paymentButtonLoading: PropTypes.bool,
   isHomepage: PropTypes.bool,
   onClickTip: PropTypes.func,
   videoType: PropTypes.string,
   unlockedDate: PropTypes.string,
   onShare: PropTypes.func,
   onSelectMembership: PropTypes.func,
   toggleWatchStatus: PropTypes.func,
   siteInfo: PropTypes.object,
   urlParamForAccess: PropTypes.bool,
   playPreviewId: PropTypes.number,
   onUpdatePlayPreviewId: PropTypes.func,
   bundleName: PropTypes.string,
   isMedia: PropTypes.object,
   isDownloaded: PropTypes.bool,
   onChangeFavoriteItem: PropTypes.func,
   className: PropTypes.string,
   thumbnailIsSfw: PropTypes.bool,
   videoPreviewIsSfw: PropTypes.bool,
   expiredDays: PropTypes.bool,
};

ContentButtonOptions.propTypes = {
   data: PropTypes.object,
   onClickLike: PropTypes.func,
   goToMediaDetails: PropTypes.func,
   isAuthUser: PropTypes.bool,
   showShare: PropTypes.bool,
   onClickTip: PropTypes.func,
   onShare: PropTypes.func,
   onClickLock: PropTypes.func,
   siteInfo: PropTypes.object,
   isHomepage: PropTypes.bool,
   showButtons: PropTypes.bool,
   stream_state: PropTypes.string,
   isMedia: PropTypes.object,
   onChangeFavoriteItem: PropTypes.func,
   collectionType: PropTypes.string,
};

ContentCard.defaultProps = {
   videoType: 'video',
   showButtons: true,
   bundleName: '',
   isDownloaded: false,
   isMedia: {
      showButtons: true,
      showNewStyles: false,
   },
}

export default memo(ContentCard);
